import React, { useEffect, useState } from "react";
import axios from "axios";
import { detalleSolicitudTodos } from "../Services/Rest";

const API_BASE_URL = "https://suadesarrollo.azurewebsites.net/api";
const AUTH_CONFIG = {
  auth: { username: "BasicAuth@icontec.org", password: "yQLzqmR7eZSuAmQZUqhY" },
};

function AsignarEquipo() {
  const [solicitudes, setSolicitudes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [postSolicitud, setPostSolicitud] = useState("");
  const [postNombre, setPostNombre] = useState("");
  const [postEquipo, setPostEquipo] = useState("");
  const [equipoSolicitud, setEquipoSolicitud] = useState([]); // lista de equipo actual
  const [postFechaInicio, setPostFechaInicio] = useState("");
  const [postFechaFin, setPostFechaFin] = useState("");

  // Cargar solicitudes y usuarios
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [solicitudRes, usuarioRes] = await Promise.all([
          axios.get(detalleSolicitudTodos, AUTH_CONFIG),
          axios.get(
            `${API_BASE_URL}/ObtenerUsuarioPorTipoUsuario?Tipo_Usuario=3`,
            AUTH_CONFIG,
          ),
        ]);
        setSolicitudes(solicitudRes.data);
        setUsuarios(usuarioRes.data);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    fetchData();
  }, []);

  // Consultar equipo actual de la solicitud seleccionada
  useEffect(() => {
    if (postSolicitud) {
      axios
        .get(
          `${API_BASE_URL}/QEquipoUsuario?SolicitudId=${postSolicitud}`,
          AUTH_CONFIG,
        )
        .then((res) => setEquipoSolicitud(res.data || []))
        .catch((error) =>
          console.error("Error al consultar equipo de la solicitud:", error),
        );
    } else {
      setEquipoSolicitud([]);
    }
  }, [postSolicitud]);

  // Guardar equipo
  const handleAsignarEquipo = async (e) => {
    e.preventDefault();

    // Validación extra: no permitir más de un líder
    const yaTieneLider = equipoSolicitud.some((m) => m.nombreRol === "LIDER");
    if (postNombre === "LIDER" && yaTieneLider) {
      alert("Ya existe un líder en esta evaluación. Solo puede haber uno.");
      return;
    }

    try {
      await axios.post(
        `${API_BASE_URL}/CreaEquipo`,
        {
          nombre: postNombre,
          evaluadorId: postEquipo,
          idRolSolicitud: "0",
          solicitudId: postSolicitud,
        },
        AUTH_CONFIG,
      );
      alert("Equipo asignado con éxito!");
    } catch (error) {
      console.error("Error al asignar equipo:", error);
      alert("Error al asignar equipo");
    }
  };

  // Guardar fechas
  const handleAsignarFecha = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_BASE_URL}/CreaFechaEquipo?fechaInicio=${postFechaInicio}&fechaFin=${postFechaFin}&SolicitudId=${postSolicitud}`,
        {},
        AUTH_CONFIG,
      );
      alert("Fecha asignada con éxito!");
    } catch (error) {
      console.error("Error al asignar fecha:", error);
      alert("Error al asignar fecha");
    }
  };

  // Filtrar solicitudes por estado
  const solicitudesFiltradas = solicitudes.filter(
    (s) => s.estado === "En Programacion",
  );

  // Verificar si ya hay líder
  const yaTieneLider = equipoSolicitud.some((m) => m.nombreRol === "LIDER");

  return (
    <div className="container">
      <h4 className="text-primary text-center">Asignar Equipo</h4>
      <form className="user" onSubmit={handleAsignarEquipo}>
        {/* Selección de solicitud */}
        <select
          className="form-control mb-3"
          onChange={(e) => setPostSolicitud(e.target.value)}
          value={postSolicitud}
        >
          <option value="">Seleccione la solicitud</option>
          {solicitudesFiltradas.map((s) => (
            <option
              key={s.solicitud}
              value={s.solicitud}
            >{`${s.nombreInstitucion} - ${s.tipoSolicitud}`}</option>
          ))}
        </select>

        {/* Selección de rol */}
        <select
          className="form-control mb-3"
          onChange={(e) => setPostNombre(e.target.value)}
          value={postNombre}
        >
          <option value="">Seleccione Rol</option>
          {yaTieneLider ? (
            <option value="EVALUADOR">Evaluador</option>
          ) : (
            <>
              <option value="LIDER">Líder</option>
              <option value="EVALUADOR">Evaluador</option>
            </>
          )}
        </select>

        {/* Selección de usuario */}
        <select
          className="form-control mb-3"
          onChange={(e) => setPostEquipo(e.target.value)}
          value={postEquipo}
        >
          <option value="">Seleccione el equipo</option>
          {usuarios.map((u) => (
            <option key={u.id} value={u.id}>
              {u.nombre}
            </option>
          ))}
        </select>

        <button className="btn btn-primary btn-block" type="submit">
          Guardar
        </button>
      </form>
      <hr />

      {/* Formulario fechas */}
      <h4 className="text-primary text-center">Asignar Fecha Visita Equipo</h4>
      <form className="user" onSubmit={handleAsignarFecha}>
        <div className="form-group row">
          <div className="col-sm-6">
            <label>Fecha Inicio</label>
            <input
              type="date"
              className="form-control"
              onChange={(e) => setPostFechaInicio(e.target.value)}
              value={postFechaInicio}
            />
          </div>
          <div className="col-sm-6">
            <label>Fecha Fin</label>
            <input
              type="date"
              className="form-control"
              onChange={(e) => setPostFechaFin(e.target.value)}
              value={postFechaFin}
            />
          </div>
        </div>
        <button className="btn btn-primary btn-block" type="submit">
          Programar
        </button>
      </form>
    </div>
  );
}

export default AsignarEquipo;
